<div class="account" *ngIf="!busy; else loadingAccount">
  <ng-container *ngIf="misdatos?.ID && misdatos?.ID != 0; else guestAccount">
    <div class="account-dropdown" [class.open]="menuOpen">
      <div class="ig-notifications" [class.open]="avisosOpen">
        <button type="button" class="ig-bell" (click)="toggleAvisos()"
          [attr.aria-expanded]="avisosOpen" aria-haspopup="true"
          [attr.aria-label]="totalPendientes ? 'Avisos pendientes: ' + totalPendientes : 'Sin avisos pendientes'"
          title="Avisos y mensajes">
          <i class="fa-regular fa-bell" aria-hidden="true"></i>
          <span class="ig-bell-count" *ngIf="totalPendientes > 0">
            {{ totalPendientes > 99 ? '99+' : totalPendientes }}
          </span>
        </button>
        <div class="ig-message-toast-stack" *ngIf="avisosMensajes.length" role="region" aria-label="Nuevos mensajes">
          <div class="ig-message-toast" *ngFor="let aviso of avisosMensajes; trackBy: trackByAvisoMensaje" role="status" aria-live="polite">
            <img class="ig-message-toast-avatar"
                 [src]="aviso.foto || global.urlServer + 'img/default-user.png'"
                 alt="Foto del remitente">
            <a class="ig-message-toast-content"
               [href]="global.urlServer + 'perfil/' + (misdatos?.slug || misdatos?.user_nicename) + '/'"
               (click)="cerrarPopupMensaje(aviso.remitenteId)">
              <span class="ig-message-toast-label"><i class="fa-solid fa-envelope"></i> Nuevo mensaje</span>
              <strong>{{ aviso.nombre }}</strong>
              <small>Te ha enviado un mensaje. Toca para verlo.</small>
            </a>
            <button type="button" class="ig-message-toast-close" (click)="cerrarPopupMensaje(aviso.remitenteId)"
                    [attr.aria-label]="'Cerrar aviso de ' + aviso.nombre" title="Cerrar">
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="ig-notifications-panel" *ngIf="avisosOpen" aria-label="Resumen de avisos">
          <div class="ig-notifications-head">
            <strong>Avisos</strong>
            <button type="button" class="ig-refresh" (click)="actualizarAvisos()" title="Actualizar avisos" aria-label="Actualizar avisos">
              <i class="fa-solid fa-rotate-right" aria-hidden="true"></i>
            </button>
          </div>
          <div class="ig-notifications-list" *ngIf="totalPendientes > 0; else noAvisos">
            <a class="ig-notice-line" *ngIf="datos.mensajes > 0" [href]="global.urlServer + 'perfil/' + (misdatos?.slug || misdatos?.user_nicename) + '/'" (click)="closeMenu()" aria-label="Ir a mi perfil para consultar mensajes sin leer">
              <span class="ig-notice-icon"><i class="fa-regular fa-envelope"></i></span>
              <span><strong>Mensajes sin leer</strong><small>Tienes conversaciones pendientes</small></span>
              <b class="ig-notice-count">{{ datos.mensajes }}</b>
              <i class="fa-solid fa-chevron-right ig-notice-arrow" aria-hidden="true"></i>
            </a>
            <a class="ig-notice-line" *ngIf="datos.solicitudes > 0" [href]="global.urlServer + 'perfil/' + (misdatos?.slug || misdatos?.user_nicename) + '/'" (click)="closeMenu()" aria-label="Ver solicitudes de amistad pendientes">
              <span class="ig-notice-icon ig-icon-solicitudes"><i class="fa-solid fa-user-plus" aria-hidden="true"></i></span>
              <span><strong>Solicitudes de amistad</strong><small>Pendientes de aceptar</small></span>
              <b class="ig-notice-count">{{ datos.solicitudes }}</b>
              <i class="fa-solid fa-chevron-right ig-notice-arrow" aria-hidden="true"></i>
            </a>
            <a class="ig-notice-line" *ngIf="datos.visitas_nuevas > 0" [href]="global.urlServer + 'perfil/' + (misdatos?.slug || misdatos?.user_nicename) + '/'" (click)="closeMenu()" aria-label="Ver visitas nuevas a mi perfil">
              <span class="ig-notice-icon ig-icon-visitas"><i class="fa-regular fa-eye" aria-hidden="true"></i></span>
              <span><strong>Visitas nuevas</strong><small>Personas que han visto tu perfil</small></span>
              <b class="ig-notice-count">{{ datos.visitas_nuevas }}</b>
              <i class="fa-solid fa-chevron-right ig-notice-arrow" aria-hidden="true"></i>
            </a>
            <a class="ig-notice-line" *ngIf="datos.notificaciones > 0" [href]="global.urlServer + 'perfil/' + (misdatos?.slug || misdatos?.user_nicename) + '/'" (click)="closeMenu()" aria-label="Ir a mi perfil para consultar notificaciones">
              <span class="ig-notice-icon"><i class="fa-regular fa-bell"></i></span>
              <span><strong>Notificaciones</strong><small>Actividad pendiente</small></span>
              <b class="ig-notice-count">{{ datos.notificaciones }}</b>
              <i class="fa-solid fa-chevron-right ig-notice-arrow" aria-hidden="true"></i>
            </a>
          </div>
          <ng-template #noAvisos>
            <div class="ig-notifications-empty">
              <i class="fa-regular fa-circle-check"></i>
              <span>Estás al día, sin avisos pendientes.</span>
            </div>
          </ng-template>
        </div>
      </div>
      <button type="button" class="account-trigger" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen" aria-haspopup="true" aria-label="Abrir menú de usuario">
        <img [src]="misdatos?.foto?.foto_principal_thumb || global.urlServer + 'img/default-user.png'" alt="" class="avatar" referrerpolicy="no-referrer">
        <span class="account-label" *ngIf="!isScrolled">{{misdatos?.first_name || 'Mi cuenta'}}</span>
        <i class="fa-solid fa-chevron-down chevron" aria-hidden="true"></i>
      </button>
      <div class="account-menu" *ngIf="menuOpen" role="menu" aria-label="Opciones de usuario">
        <div class="account-summary">
          <img [src]="misdatos?.foto?.foto_principal_thumb || global.urlServer + 'img/default-user.png'" alt="" class="summary-avatar">
          <div class="summary-details"><strong>{{misdatos?.first_name || 'Usuario de iGuau'}}</strong><span *ngIf="misdatos?.user_email">{{misdatos.user_email}}</span><span *ngIf="!misdatos?.user_email">Cuenta iGuau</span></div>
        </div>
        <div class="menu-links">
          <a role="menuitem" [href]="global.urlServer + 'perfil/' + misdatos.slug"><i class="fa-regular fa-user"></i> Mi perfil</a>
          <a role="menuitem" [href]="global.urlServer + 'opciones'"><i class="fa-solid fa-gear"></i> Configuración</a>
          <a role="menuitem" [href]="global.urlServer + 'muros'"><i class="fa-regular fa-comments"></i> Publicaciones</a>
          <a role="menuitem" [href]="global.urlServer + 'perfiles'"><i class="fa-solid fa-paw"></i> Descubrir mascotas</a>
        </div>
        <div class="logout-section"><button type="button" role="menuitem" class="logout-action" [disabled]="cerrandoSesion" (click)="logout()"><i class="fa-solid fa-arrow-right-from-bracket"></i> {{cerrandoSesion ? 'Cerrando sesión…' : 'Cerrar sesión'}}</button></div>
      </div>
    </div>
  </ng-container>
  <ng-template #guestAccount><a class="guest-link" [href]="global.urlServer + 'login'"><i class="fa-regular fa-user"></i><span>Entrar</span></a></ng-template>
</div>
<ng-template #loadingAccount><div class="loading-account" aria-label="Cargando cuenta"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span></div></ng-template>
